import React, { useEffect, useMemo, useRef } from "react";
import "../../../assets/css/Excursion.css";
import { ChevronLeftIcon } from "../../../helper/HwIconExcursion";
import { ExcursionCard } from "./components/ExcursionCard";
import { PersonDetailsCard } from "./components/PersonDetailsCard";
import { TourSummary } from "./components/TourSummary";
import { Payment } from "./components/Payment";
import { Tickets } from "./components/Tickets";
import { PriceBreakdown } from "./components/PriceBreakdown";
import { BookingConfirmationAlert } from "./components/BookingConfirmationAlert";
import { BookingProcessingOverlay } from "./components/BookingProcessingOverlay";
import ExcursionConfirmSkeleton from "./components/ExcursionConfirmSkeleton";
import { getExcurstionDetails } from "../details/getExcurstionDetails";
import { useCheckout } from "./useCheckout";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { formatDateFormat } from "../../../helper/commonFunction";
import { Formik } from "formik";
import Skeleton from "react-loading-skeleton";

import * as Yup from "yup";
import { useDoPayment } from "./useDoPayment";
// import StripeWrapper from "../../component/StripeWrapper";
import StripeWrapper from "../../../component/StripeWrapper";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useGetTickets } from "./useGetTickets";
import CommonPopup from "../../common-popup/CommonPopup";
import { DownloadIcon, UserIcon, ChevronDownIcon } from "../../../helper/HwIcon";
import { setBookingView, clearBookingView } from "../../../helper/currencyState";
import { formatePriceFn, formatPrice } from "../../../helper/commonFunction";

const showWeightForHeliDubai = false;
const whiteSpaceRegex = /^.*\S.*$/;
const personSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  gender: Yup.string().required("Gender is required"),
  firstName: Yup.string()
    .required("First name is required")
    .matches(whiteSpaceRegex, "First name is required"),
  lastName: Yup.string()
    .required("Last name is required")
    .matches(whiteSpaceRegex, "Last name is required"),
  // nationality: Yup.mixed().required("Nationality is required"),
  // phoneNumber: Yup.string()
  //   .required("Phone number is required")
  //   .max(10, "Please enter valid Phone number")
  //   .matches(whiteSpaceRegex, "Phone number is required"),
});

const personIsDubaiParkSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  gender: Yup.string().required("Gender is required"),
  firstName: Yup.string()
      .required("First name is required")
      .matches(whiteSpaceRegex, "First name is required"),
  lastName: Yup.string()
      .required("Last name is required")
      .matches(whiteSpaceRegex, "Last name is required"),
  nationality: Yup.mixed().required("Nationality is required"),
  // phoneNumber: Yup.string()
  //   .required("Phone number is required")
  //   .max(10, "Please enter valid Phone number")
  //   .matches(whiteSpaceRegex, "Phone number is required"),
});

const personSchemaHeliDubai = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  gender: Yup.string().required("Gender is required"),
  firstName: Yup.string()
    .required("First name is required")
    .matches(whiteSpaceRegex, "First name is required"),
  lastName: Yup.string()
    .required("Last name is required")
    .matches(whiteSpaceRegex, "Last name is required"),
  phoneNumber: Yup.string()
    .required("Phone number is required")
    .min(6, "Phone number must be at least 6 characters")
    .max(15, "Phone number cannot exceed 15 characters")
    .matches(/^[0-9+()]+$/, "Please enter valid Phone number"),
  weight: !showWeightForHeliDubai
    ? undefined
    : Yup.string()
        .required("Weight is required")
        .matches(whiteSpaceRegex, "Weight is required")
        .matches(/^[0-9]*$/, "Please enter valid weight"),
});

const commonPersonPayload = {
  gender: "",
  firstName: "",
  lastName: "",
  nationality: "",
  phoneNumber: "",
  weight: "",
};

const ExcursionCheckout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const changeRef = useRef({});
  const {
    data,
    loading,
    variationId,
    date,
    time,
    endTime,
    persons,
    transfer,
    id,
    eventId,
    totalPrice,
    adultPrice,
    childPrice,
    infantPrice,
    ageGroup,
    TourProductId,
    TourScheduleId,
    TourId,
    duration,
    onlineServiceFeeAmount,
    IsEventBased,
    totalTax,
    taxData,
    jwt, openDay, vendorBased, slotData, resourceId, IsEticketRequired, pricesObject  , error : sessionError , setError : setSessionError , ready, commonId, queryData
  } = getExcurstionDetails();
  const {
    doTransaction,
    confirmAfterOnlinePayment,
    loading: paymentLoading,
    error: errorMsg,
    setError : ErrorSet
  } = useDoPayment(totalPrice, onlineServiceFeeAmount);

  const searchQuery = new URLSearchParams(location.search);

  const backToSearchPath = () => {
    return "/excursion/search";
  };
  const selectedVariation = data?.singleExcursionData?.excursion_variations?.find?.(
    (d) => String(d?.variation_unique_id) === String(variationId)
  );
  const isBurjKhalifaRaynaParmar =
    ["rayna", "parmar"].includes(String(selectedVariation?.vendor ?? data?.vendor ?? "").toLowerCase()) &&
    String(data?.singleTitle ?? "").toLowerCase().includes("burj khalifa");
  const { agentActiveCurrency, onlinePaymentEnable, displayPrice } = useSelector((state) => state.userData);
  const [stripeModalShow, setStripeModalShow] = useState(false);
  const [onlinePaymentPayload,setonlinePaymentPayload]=useState(null)
  const [activeStep, setActiveStep] = useState(1);
  const [agreeError, setAgreeError] = useState(false);
  const [travelerDetailsOpen, setTravelerDetailsOpen] = useState(true);

  const {
    bookingId,
    loading: bookingDetailsLoading,
    data: bookingDetails,
    downloadPDF,
    pdfLoading,
  } = useCheckout();


  const adults = Array(+(persons?.[0] ?? 0))?.fill(Math.random());
  const child = Array(+(persons?.[1] ?? 0))?.fill(Math.random());
  const infants = Array(+(persons?.[2] ?? 0))?.fill(Math.random());
  const totalPersons = adults?.length + child?.length + infants?.length;

  const formRef = useRef();

  const validationSchema = Yup.object().shape({
    adults: Yup.array()
      .of(data?.isHelidubai ? personSchemaHeliDubai  : data?.isDubaiPark ? personIsDubaiParkSchema : personSchema)
      .min(1, "At least one adult is required"),
    child: Yup.array().of(
        data?.isHelidubai ? personSchemaHeliDubai  : data?.isDubaiPark ? personIsDubaiParkSchema : personSchema
    ),
    infants: Yup.array().of(
        data?.isHelidubai ? personSchemaHeliDubai  : data?.isDubaiPark ? personIsDubaiParkSchema : personSchema
    ),
    paymentMethod: Yup.string().required("Please select payment method"),
  });

  const {
    loading: ticketsLoading,
    refresh,
    groupData,
    error,
    setError,
    convertToAdult,
    data: Ticket,
    getEmaarV1Tickets
  } = useGetTickets(IsEventBased, commonId);

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  useEffect(() => {
    if (bookingId && bookingDetails?.display_currency) {
      setBookingView(bookingDetails.display_currency, bookingDetails.conversion_rate);
    } else {
      clearBookingView();
    }
    return () => clearBookingView();
  }, [bookingId, bookingDetails?.display_currency, bookingDetails?.conversion_rate]);

  useEffect(() => {
    if (bookingId) {
      return;
    }
    if (eventId && data?.isEmaar) {
      refresh({
        time,
        endTime,
        eventId,
        variationId,
        id,
        adults: adults?.length,
        child: child?.length,
        infants: infants?.length,
        date
      });
    } else if (eventId && data?.isEmaarV1) {
      getEmaarV1Tickets({
        excursionId : data?.singleId,
        EventID: slotData?.EventID,
        EventName: slotData?.EventName,
        StartDateTime: slotData?.StartDateTime,
        EndDateTime: slotData?.EndDateTime,
        EventTypeId: variationId,
        ResourceID: resourceId,
        Available: slotData?.Available,
        Status: slotData?.Status,
        Infant: infants?.length,
        Child: child?.length,
        Adult: adults?.length
      })
    }
  }, [
    eventId,
    adults?.length,
    child?.length,
    infants?.length,
    data?.isEmaar,
    bookingId,
  ]);

  const variationTitle = useMemo(() => {
    return (
      data?.singleExcursionData?.excursion_variations?.find?.((d) => {
        return String(d?.variation_unique_id) === String(variationId);
      })?.variation_title ?? data?.singleTitle
    );
  }, [data?.singleId, data?.singleExcursionData, variationId]);

  const onSubmit = async (values) => {
    const payload = {
      date,
      eId: id,
      endTime,
      time,
      eventId,
      isEmaar: data?.isEmaar,
      isEmaarV1: data?.isEmaarV1,
      isHelidubai: data?.isHelidubai,
      isDubaiPark: data?.isDubaiPark,
      isDubaiProductId: data?.singleExcursionData?.emaar_excursion_ticket_id,
      paymentMethod: values?.paymentMethod,
      persons: [
        ...(values?.adults?.map?.((d) => {
          return {
            ...d,
            type: "adult",
            price: pricesObject?.['adult']?.finalAmount ?? groupData?.adultGroup?.TicketPrice ?? 0,
            finalAmount: pricesObject?.['adult']?.finalAmount ?? 0,
            taxAmount: pricesObject?.['adult']?.taxAmount ?? 0,
            baseAmount: pricesObject?.['adult']?.baseAmount ?? 0,
            nationality: d?.nationality?.value,
          };
        }) ?? []),
        ...(values?.child?.map?.((d) => {
          return {
            ...d,
            type: "child",
            price: pricesObject?.['child']?.finalAmount ?? groupData?.childGroup?.TicketPrice ?? 0,
            finalAmount: pricesObject?.['child']?.finalAmount ?? 0,
            taxAmount: pricesObject?.['child']?.taxAmount ?? 0,
            baseAmount: pricesObject?.['child']?.baseAmount ?? 0,
            nationality: d?.nationality?.value,
          };
        }) ?? []),
        ...(values?.infants?.map?.((d) => {
          return {
            ...d,
            type: "infant",
            price:
              pricesObject?.['infant']?.finalAmount ?? groupData?.infantGrup?.TicketPrice ??
              0,
            finalAmount: pricesObject?.['infant']?.finalAmount ?? 0,
            taxAmount: pricesObject?.['infant']?.taxAmount ?? 0,
            baseAmount: pricesObject?.['infant']?.baseAmount ?? 0,
            nationality: d?.nationality?.value,
          };
        }) ?? []),
      ],
      price: totalPrice,
      bookingReference: values?.bookingReference,
      emaarV1Tickets: Ticket,
      tickets: [
        groupData?.adultGroup && adults?.length > 0
          ? {
              ...(groupData?.adultGroup ? groupData?.adultGroup : {}),
              Quantity: adults?.length,
            }
          : undefined,
        groupData?.childGroup && child?.length > 0
          ? {
              ...(groupData?.childGroup ? groupData?.childGroup : {}),
              Quantity: child?.length,
            }
          : undefined,
        groupData?.infantGrup && infants?.length > 0
          ? {
              ...(groupData?.infantGrup ? groupData?.infantGrup : {}),
              Quantity: infants?.length,
              ...(convertToAdult
                ? {
                    TicketGroup: "Adult",
                  }
                : {}),
            }
          : undefined,
      ].filter((d) => d),
      transfer,
      variationId,
      variationTitle,
      productName: data?.singleTitle,
      TourProductId,
      TourScheduleId,
      TourId,
      duration,
      IsEventBased,
      jwt,
      openDay,
      vendorBased,
      IsEticketRequired,
      slotData,
      taxData,
      commonId,
      raynaData:
        (selectedVariation?.vendor ?? data?.vendor) === "rayna"
          ? {
              vendor: "rayna",
              excursionId: selectedVariation?.tourId ?? data?.singleId,
              tourOptionId: selectedVariation?.tourOptionId ?? variationId,
              contractId: selectedVariation?.contractId,
              transferId: slotData?.transferId ?? selectedVariation?.transferId,
              timeSlotId: slotData?.timeSlotId,
              startTime: slotData?.timeSlot
                ? `${slotData.timeSlot}:00`.slice(0, 8)
                : selectedVariation?.startTime ?? "",
              adultRate: adultPrice,
              childRate: childPrice,
              serviceTotal: totalPrice,
              pickup: "",
              commonId,
              originalPrices:
                selectedVariation?.transfers?.find(
                  (t) =>
                    String(t?.transferId) ===
                    String(slotData?.transferId ?? selectedVariation?.transferId)
                )?.originalPrices ?? selectedVariation?.originalPrices,
              googleNavigation: selectedVariation?.googleNavigation,
              address: selectedVariation?.address ?? "",
              importantInformation: data?.singleExcursionData?.excursion_ticket_highlights ?? "",
            }
          : undefined,
      parmarData:
        (selectedVariation?.vendor ?? data?.vendor) === "parmar"
          ? {
              vendor: "parmar",
              excursionId: selectedVariation?.tourId ?? data?.singleId,
              variationId: selectedVariation?.variation_unique_id ?? variationId,
              variationTitle,
              parmarKind: selectedVariation?.parmarKind ?? data?.parmarKind ?? "single",
              entry_time: slotData?.entry_time ?? "",
              exit_time: slotData?.exit_time ?? "",
              timeSlotId: slotData?.timeSlotId ?? "",
              adultTicketId: selectedVariation?.adultTicketId ?? null,
              childTicketId: selectedVariation?.childTicketId ?? null,
              infantTicketId: selectedVariation?.infantTicketId ?? null,
              adultRate: adultPrice,
              childRate: childPrice,
              serviceTotal: totalPrice,
              address: data?.singleExcursionData?.address ?? "",
              importantInformation: data?.singleExcursionData?.excursion_ticket_highlights ?? "",
              commonId,
            }
          : undefined,
    };
    if (values?.paymentMethod === "online") {
      setonlinePaymentPayload(payload)
      setStripeModalShow(true);
    } else {
      doTransaction?.(totalPrice, payload);
    }
  };

  if (bookingId && bookingDetailsLoading) {
    return (
      <>
        <div className="mb-0 hw-adjust--div" />
        <div className="hw-widget hw-widget--ticketCheckout">
          <div className="hw-passenger--pageList">
            <ExcursionConfirmSkeleton />
          </div>
        </div>
      </>
    );
  }

  if (ticketsLoading || bookingDetailsLoading || loading || !ready) {
    return (
      <div className={`hw-widget hw-widget--excursion`}>
        <div className="hw-page--width">
          <div className="hw-excursion--list">
            <div className="row">
              <div className="col-md-12">
                <Skeleton width={"100%"} height={"80px"} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Skeleton width={"100%"} height={"300px"} />
              </div>
              <div className="col-md-6">
                <Skeleton width={"100%"} height={"300px"} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Skeleton width={"100%"} height={"160px"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="mb-0 hw-adjust--div"/>
      <div className={`hw-widget hw-widget--ticketCheckout`}>
        <div className="hw-passenger--pageList">
          <CommonPopup
            show={error || sessionError}
            setShow={() => {
              setError(null);
              setSessionError(null);
              navigate('/');
            }}
          >
            <p>{error || sessionError}</p>
          </CommonPopup>
          <BookingConfirmationAlert id={bookingDetails?.booking_ref_no || bookingId} status={bookingDetails?.booking_status} onBack={() => navigate(backToSearchPath())} />
          <Formik
            innerRef={formRef}
            initialValues={{
              paymentMethod: "wallet",
              addBookingReference: true,
              bookingReference: "",
              adults: adults?.map((d) => {
                return {
                  type: "adults",
                  ...commonPersonPayload,
                };
              }),
              child: child?.map((d) => {
                return {
                  type: "child",
                  ...commonPersonPayload,
                };
              }),
              infants: infants?.map((d) => {
                return {
                  type: "infants",
                  ...commonPersonPayload,
                };
              }),
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              onSubmit(values);
            }}
          >
            {({ values, setFieldValue, errors, touched }) => {
              if (!bookingId) {
                const payLoading = paymentLoading || loading || ticketsLoading || bookingDetailsLoading;
                const grandTotal =
                  parseFloat(totalPrice || 0) +
                  (values?.paymentMethod === "online" ? parseFloat(onlineServiceFeeAmount || 0) : 0);
                const markPaxTouched = () => {
                  const v = formRef.current?.values || {};
                  const mk = (arr) =>
                    (arr || []).map(() => ({
                      gender: true, firstName: true, lastName: true,
                      nationality: true, phoneNumber: true, weight: true,
                    }));
                  formRef.current?.setTouched?.(
                    { adults: mk(v.adults), child: mk(v.child), infants: mk(v.infants) },
                    false
                  );
                };
                const goToPayment = async () => {
                  const errs = (await formRef.current?.validateForm?.()) || {};
                  if (errs.adults || errs.child || errs.infants) {
                    markPaxTouched();
                    return;
                  }
                  setActiveStep(2);
                  window.scrollTo(0, 0);
                };
                const payNow = async () => {
                  if (payLoading) return;
                  const errs = (await formRef.current?.validateForm?.()) || {};
                  if (errs.adults || errs.child || errs.infants) {
                    setActiveStep(1);
                    markPaxTouched();
                    return;
                  }
                  if (!formRef.current?.values?.agreeTerms) {
                    setAgreeError(true);
                    return;
                  }
                  formRef.current?.handleSubmit?.();
                };
                const goStep = (n) => { setActiveStep(n); window.scrollTo(0, 0); };
                const mobilePrimary = () => {
                  if (activeStep === 1) goToPayment();
                  else payNow();
                };
                const STEPS = [
                  { n: 1, label: "Your details" },
                  { n: 2, label: "Payment" },
                ];
                const termsNode = (
                  <div className="hw-exchk--agree">
                    <label className="hw-exchk--agreeCheck">
                      <input
                        type="checkbox"
                        checked={!!values?.agreeTerms}
                        onChange={(e) => {
                          setFieldValue("agreeTerms", e.target.checked);
                          if (e.target.checked) setAgreeError(false);
                        }}
                      />
                      <span>
                        By continuing you agree to our{" "}
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={`${process.env.wordpressApiEndPoint}terms-conditions`}
                          className="hw-link--line"
                        >
                          Terms &amp; Conditions
                        </a>{" "}
                        and{" "}
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={`${process.env.wordpressApiEndPoint}privacy-policy`}
                          className="hw-link--line"
                        >
                          Privacy Policy
                        </a>
                      </span>
                    </label>
                    {agreeError ? (
                      <p className="hw-p-error-cls">Please accept the Terms &amp; Conditions to continue.</p>
                    ) : null}
                  </div>
                );
                const Ico = {
                  chevron: (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  ),
                  check: (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  ),
                  shield: (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  ),
                  bolt: (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/></svg>
                  ),
                  lock: (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="4.5" y="10.5" width="15" height="10" rx="2" stroke="currentColor" strokeWidth="1.7"/><path d="M8 10.5V8a4 4 0 018 0v2.5" stroke="currentColor" strokeWidth="1.7"/></svg>
                  ),
                };
                return (
                  <div className="hw-exchk">
                    <div className="hw-exchk--hero">
                      <div className="hw-exchk--heroInner">
                      <button
                        type="button"
                        className="hw-exchk--back"
                        onClick={() => { if (activeStep === 2) { goStep(1); } else { navigate(backToSearchPath()); } }}
                      >
                        <ChevronLeftIcon /> Back
                      </button>
                      <div className="hw-exchk--heroBar">
                        <h1 className="hw-exchk--heroTitle">Complete Your Booking</h1>
                        <ol className="hw-exchk--steps">
                          {STEPS.map((s) => (
                            <li
                              key={s.n}
                              className={`hw-exchk--step ${activeStep === s.n ? "is-active" : ""} ${activeStep > s.n ? "is-done" : ""}`}
                              onClick={() => { if (s.n < activeStep) goStep(s.n); }}
                            >
                              <span className="hw-exchk--stepNum">{activeStep > s.n ? Ico.check : s.n}</span>
                              <span className="hw-exchk--stepLabel">{s.label}</span>
                            </li>
                          ))}
                        </ol>
                      </div>
                      </div>
                    </div>

                    <div className="hw-exchk--body">
                    <div className="hw-exchk--grid">
                      <div className="hw-exchk--main">
                        {activeStep === 1 ? (
                          <div className="hw-exchk--panel">
                            <div className="hw-exchk--sectionHead">
                              <span className="hw-exchk--sectionIcon"><UserIcon /></span>
                              <span className="hw-exchk--sectionTitle">Traveler Details</span>
                           
                            </div>
                            <div className="hw-passenger--detailsGroup">
                              {values?.adults?.map?.((item, i) => (
                                <PersonDetailsCard
                                  key={`a-${i}`}
                                  isEmaar={data?.isEmaar}
                                  isEmaarV1={data?.isEmaarV1}
                                  isBurjKhalifa={isBurjKhalifaRaynaParmar}
                                  isHelidubai={data?.isHelidubai}
                                  isDubaiPark={data?.isDubaiPark}
                                  showWeightForHeliDubai={showWeightForHeliDubai}
                                  title={`Adult ${i + 1} : (${data?.singleExcursionData?.excursion_ticket_adult_age_limit || "8+ Years"})`}
                                  values={item}
                                  index={i}
                                  item={item}
                                  setFieldValue={(...args) => {
                                    setFieldValue(...args);
                                    const key = args?.[2];
                                    if (!changeRef.current?.[key]) {
                                      changeRef.current = {
                                        ...changeRef.current,
                                        [key]: true,
                                      };
                                    }
                                  }}
                                  errors={errors?.[item?.type]?.[i]}
                                  touched={touched?.[item?.type]?.[i]}
                                  mainForm={i === 0}
                                  allValues={values}
                                  totalPersons={totalPersons}
                                  startFrom={1}
                                  changeRef={changeRef.current}
                                />
                              ))}
                              {values?.child?.map?.((item, i) => (
                                <PersonDetailsCard
                                  key={`c-${i}`}
                                  isHelidubai={data?.isHelidubai}
                                  isDubaiPark={data?.isDubaiPark}
                                  showWeightForHeliDubai={showWeightForHeliDubai}
                                  title={`Child ${i + 1} : (${data?.singleExcursionData?.excursion_ticket_child_age_limit || "Above 3 - 8 Years"})`}
                                  values={item}
                                  index={i}
                                  item={item}
                                  setFieldValue={setFieldValue}
                                  errors={errors?.[item?.type]?.[i]}
                                  touched={touched?.[item?.type]?.[i]}
                                />
                              ))}
                              {values?.infants?.map?.((item, i) => (
                                <PersonDetailsCard
                                  key={`i-${i}`}
                                  isHelidubai={data?.isHelidubai}
                                  isDubaiPark={data?.isDubaiPark}
                                  showWeightForHeliDubai={showWeightForHeliDubai}
                                  title={`Infant ${i + 1} : (${data?.singleExcursionData?.excursion_ticket_infant_age_limit || "Below 3"})`}
                                  values={item}
                                  index={i}
                                  item={item}
                                  setFieldValue={setFieldValue}
                                  errors={errors?.[item?.type]?.[i]}
                                  touched={touched?.[item?.type]?.[i]}
                                />
                              ))}
                            </div>
                            <div className="hw-exchk--stickyFoot">
                              <button type="button" className="hw-btn hw-btn--primary hw-exchk--btnWide" onClick={goToPayment}>
                                Continue to Payment
                              </button>
                            </div>
                          </div>
                        ) : null}

                        {activeStep === 2 ? (
                          <div className="hw-exchk--panel">
                            <div className="hw-exchk--panelTitle">Select Payment Method</div>
                            <Payment
                              hideButton
                              setFieldValue={(name, value) => { formRef?.current?.setFieldValue(name, value); }}
                              onContinue={payNow}
                              selectedMethod={values?.paymentMethod}
                              error={formRef?.current?.touched?.paymentMethod && formRef?.current?.errors?.paymentMethod}
                              loading={payLoading}
                              errorFromAPI={errorMsg}
                              onlinePaymentEnable={onlinePaymentEnable}
                              setError={ErrorSet}
                            />
                            <div className="hw-exchk--field hw-exchk--bookingRef">
                              <label className="hw-exchk--label">
                                Booking Reference <span className="hw-exchk--optional">(optional)</span>
                              </label>
                              <input
                                placeholder="Enter booking reference"
                                className="hw-form--input"
                                onChange={(e) => setFieldValue("bookingReference", e.target.value)}
                                value={values?.bookingReference || ""}
                              />
                            </div>
                            {termsNode}
                          </div>
                        ) : null}
                      </div>

                      <aside className="hw-exchk--aside">
                        <div className="hw-exchk--summary">
                          <div className="hw-exchk--tourCard">
                            {data?.singleThumbnail ? (
                              <img className="hw-exchk--tourImg" src={data?.singleThumbnail} alt={data?.singleTitle || "tour"} />
                            ) : null}
                            <div className="hw-exchk--tourInfo">
                              <div className="hw-exchk--tourTitle">{data?.singleTitle}</div>
                              {variationTitle ? (
                                <div className="hw-exchk--tourVariation">{variationTitle}</div>
                              ) : null}
                              {/* <button type="button" className="hw-exchk--edit" onClick={() => navigate(backToSearchPath())}>Edit</button> */}
                            </div>
                          </div>
                          <ul className="hw-exchk--facts">
                            {date ? (
                              <li>
                                <span className="hw-exchk--factLbl">Date</span>
                                <span className="hw-exchk--factVal">{formatDateFormat(date)}</span>
                              </li>
                            ) : null}
                            {time && /\d{1,2}:\d{2}/.test(String(time)) && moment.parseZone(time).isValid() && moment.parseZone(time).format("HH:mm") !== "00:00" ? (
                              <li>
                                <span className="hw-exchk--factLbl">Time</span>
                                <span className="hw-exchk--factVal">{moment.parseZone(time).format("HH:mm A")}</span>
                              </li>
                            ) : null}
                            {transfer ? (
                              <li>
                                <span className="hw-exchk--factLbl">Transfer</span>
                                <span className="hw-exchk--factVal">{data?.excursionTransfer?.[transfer] ?? transfer}</span>
                              </li>
                            ) : null}
                            <li>
                              <span className="hw-exchk--factLbl">Persons</span>
                              <span className="hw-exchk--factVal">Adult {persons?.[0] ?? 0} · Child {persons?.[1] ?? 0} · Infant {persons?.[2] ?? 0}</span>
                            </li>
                          </ul>
                          <div className="hw-exchk--summaryDivider" />
                          <TourSummary
                            totalPrice={totalPrice}
                            taxPrice={totalTax}
                            onlineServiceFeeAmount={values?.paymentMethod === "online" ? onlineServiceFeeAmount : undefined}
                            ageGroup={ageGroup}
                          />
                          {activeStep !== 1 ? (
                            <div className="hw-exchk--asideCta">
                              <button type="button" className="hw-btn hw-btn--primary hw-exchk--btnWide" disabled={payLoading} onClick={payNow}>
                                {payLoading ? <span style={{ minWidth: "2.8rem", minHeight: "2.8rem" }} className="hw-main--loaderCommon" /> : "Pay Now"}
                              </button>
                              {/* <button type="button" className="hw-exchk--asideBack" onClick={() => goStep(1)}>Back to details</button> */}
                            </div>
                          ) : null}
                        </div>
                      </aside>
                    </div>
                    </div>

                    <div className="hw-exchk--mobileBar">
                      <div className="hw-exchk--mobileTotal">
                        <span>Total</span>
                        <strong>{formatePriceFn(agentActiveCurrency, formatPrice(grandTotal, false, false, true), displayPrice)}</strong>
                      </div>
                      <button type="button" className="hw-btn hw-btn--primary" disabled={activeStep === 3 && payLoading} onClick={mobilePrimary}>
                        {activeStep < 3 ? "Continue" : payLoading ? "..." : "Pay Now"}
                      </button>
                    </div>
                  </div>
                );
              }
              return (
                <div className="hw-exchk hw-exchk--confirm">
                  <div className="hw-exchk--body">
                    <div className="hw-exchk--grid">
                      <div className="hw-exchk--main">
                        <div className="hw-exchk--panel">
                          <div
                            className={`hw-exchk--sectionHead hw-exchk--sectionHead__toggle ${travelerDetailsOpen ? "is-open" : ""}`}
                            onClick={() => setTravelerDetailsOpen((v) => !v)}
                            role="button"
                          >
                            <span className="hw-exchk--sectionIcon"><UserIcon /></span>
                            <span className="hw-exchk--sectionTitle">Traveler Details</span>
                            <span className="hw-exchk--sectionToggle">
                              <span className="hw-exchk--sectionMeta">Name
                              </span>
                              <span className="hw-exchk--sectionChevron">
                                <ChevronDownIcon />
                              </span>
                            </span>
                          </div>
                          <div className={`hw-exchk--collapseWrapper ${travelerDetailsOpen ? "is-open" : ""}`}>
                            <div className="hw-exchk--collapseInner">
                              <div className="hw-hotel--reviewRoomCard">
                                <div className="hw-hotel--reviewRoomHead">
                                  <span className="hw-hotel--reviewRoomBadge">Travelers</span>
                                  <span className="hw-hotel--reviewRoomCount">Tickets
                                  </span>
                                </div>
                                <ul className="hw-hotel--reviewList">
                                  {bookingDetails?.tickets?.map?.((d, ti) => {
                                    const typeLabel = d?.type
                                      ? (d.type.charAt(0).toUpperCase() + d.type.slice(1).toLowerCase())
                                      : "Adult";
                                    return (
                                      <li className="hw-hotel--reviewGuest" key={ti}>
                                        {/* <span className="hw-hotel--reviewGuestIcon">
                                          <UserIcon />
                                        </span> */}
                                        <span className="hw-hotel--reviewGuestName">
                                          {d?.name}
                                        </span>
                                        <div className="d-flex align-items-center hw-gapxy10" >
                                          <span className="hw-hotel--reviewGuestType">{typeLabel}</span>
                                          {d?.downloadLink ? (
                                            <a
                                              className="hw-exchk--dl"
                                              href={d?.downloadLink}
                                              target="_blank"
                                              rel="noreferrer"
                                              title="Download Ticket"
                                            >
                                              <DownloadIcon />
                                            </a>
                                          ) : null}
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </div>
                          </div>
                          {bookingId && (bookingDetails?.booking_status === "confirm" || bookingDetails?.booking_status === "pending") ? (
                            <div className="hw-exchk--ticketsSection hw-exchk--dlInline">
                              <div className="hw-exchk--panelSubTitle">Download Tickets</div>
                              <Tickets
                                downloadPDF={downloadPDF}
                                pdfLoading={pdfLoading}
                                bookingDetails={bookingDetails}
                              />
                            </div>
                          ) : null}
                        </div>

                        {bookingDetails?.importantInformation ? (
                          <div className="hw-exchk--panel">
                            <div className="hw-exchk--panelTitle">Important information</div>
                            <div
                              className="hw-exchk--richText"
                              dangerouslySetInnerHTML={{ __html: bookingDetails?.importantInformation }}
                            />
                          </div>
                        ) : null}
                      </div>

                      <aside className="hw-exchk--aside">
                        <div className="hw-exchk--summary">
                          <div className="hw-exchk--tourCard">
                            {bookingDetails?.thumbnail ? (
                              <img className="hw-exchk--tourImg" src={bookingDetails?.thumbnail} alt={bookingDetails?.tour_title || "tour"} />
                            ) : null}
                            <div className="hw-exchk--tourInfo">
                              <div className="hw-exchk--tourTitle">{bookingDetails?.tour_title}</div>
                              {bookingDetails?.variation_title ? (
                                <div className="hw-exchk--tourVariation">{bookingDetails?.variation_title}</div>
                              ) : null}
                            </div>
                          </div>
                          <ul className="hw-exchk--facts">
                            {bookingDetails?.travel_date ? (
                              <li>
                                <span className="hw-exchk--factLbl">Date</span>
                                <span className="hw-exchk--factVal">{formatDateFormat(bookingDetails?.travel_date)}</span>
                              </li>
                            ) : null}
                            {bookingDetails?.TimeSlot && /\d{1,2}:\d{2}/.test(String(bookingDetails?.TimeSlot)) && moment.parseZone(bookingDetails?.TimeSlot).isValid() && moment.parseZone(bookingDetails?.TimeSlot).format("HH:mm") !== "00:00" ? (
                              <li>
                                <span className="hw-exchk--factLbl">Time</span>
                                <span className="hw-exchk--factVal">{moment.parseZone(bookingDetails?.TimeSlot).format("HH:mm A")}</span>
                              </li>
                            ) : null}
                            {bookingDetails?.transfer_type ? (
                              <li>
                                <span className="hw-exchk--factLbl">Transfer</span>
                                <span className="hw-exchk--factVal">{bookingDetails?.transfer_type}</span>
                              </li>
                            ) : null}
                            <li>
                              <span className="hw-exchk--factLbl">Persons</span>
                              <span className="hw-exchk--factVal">
                                {(!bookingDetails?.isEmaar && !bookingDetails?.isEmaarV1)
                                  ? `Adult ${bookingDetails?.tickets?.filter((d) => d?.type === "adult")?.length ?? 0} · Child ${bookingDetails?.tickets?.filter((d) => d?.type === "child")?.length ?? 0} · Infant ${bookingDetails?.tickets?.filter((d) => d?.type === "infant")?.length ?? 0}`
                                  : `Adult ${bookingDetails?.total_adult ?? 1} · Child ${bookingDetails?.total_child ?? 0} · Infant ${bookingDetails?.total_infant ?? 0}`}
                              </span>
                            </li>
                          </ul>
                          <div className="hw-exchk--summaryDivider" />
                          <PriceBreakdown totalPrice={bookingDetails?.price} bookingDetails={bookingDetails} />
                        </div>
                      </aside>
                    </div>
                  </div>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {paymentLoading ? <BookingProcessingOverlay /> : null}
      {!paymentLoading && (loading || ticketsLoading || bookingDetailsLoading) ? (
        <div
          style={{
            zIndex: 1000,
            minWidth: "80vw",
            minHeight: "80vh",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "#00000060",
            overflow: "hidden",
          }}
          className="hw-main--loaderCommon"
        />
      ) : null}
      <StripeWrapper
        show={stripeModalShow}
        setShow={setStripeModalShow}
        totalPrice={((parseFloat(totalPrice || 0) + parseFloat(onlineServiceFeeAmount || 0)))}
        showDiscounts={true}
        extraChargePrice={{ total: onlineServiceFeeAmount || 0 }}
        queryParams={{}}
        bookingOtherData={{}}
        selectPaymentMethod={1}
        onineServicesFees={0}
        agentActiveCurrency={agentActiveCurrency || 'AED'}
        displayPrice={displayPrice}
        onPaymentSuccess={async (paymentMethod) => {
          await confirmAfterOnlinePayment(totalPrice, onlinePaymentPayload, paymentMethod);
          setStripeModalShow(false);
        }}
        onClose={() => {
          setStripeModalShow(false);
        }}
        isExcursion={true}
      />
      {/* Simplify payment button temporarily disabled due to integration issues */}
      {/* {onlineServiceFeeAmount !== undefined ? (
        <button
          style={{ display: "none" }}
          data-sc-key={process.env.SIMPLIFY_PUBLIC_KEY}
          data-color="#3264FF"
          data-name=""
          data-description="excursion"
          className="hw-btn hw-btn--primary w-100 online_book_now_btn"
          data-amount={((totalPrice + onlineServiceFeeAmount) * 100).toString()}
        >
          Pay Now
        </button>
      ) : null} */}
    </>
  );
};

export default ExcursionCheckout;
